export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 text-white relative overflow-hidden">
      {/* Map Pattern Background */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <svg className="w-full h-full" viewBox="0 0 1000 1000">
          <defs>
            <pattern id="map-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <circle cx="50" cy="50" r="1" fill="currentColor" />
              <line x1="0" y1="50" x2="100" y2="50" stroke="currentColor" strokeWidth="0.5" />
              <line x1="50" y1="0" x2="50" y2="100" stroke="currentColor" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="1000" height="1000" fill="url(#map-pattern)" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16 relative z-10">
        {/* Upper Footer */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Column 1 - Logo & Newsletter */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/ffae8172-0ef8-4e98-8a39-3b44a213e56d.png" 
                alt="Destination Essaouira" 
                className="h-10 w-auto"
              />
              <span className="text-lg font-bold whitespace-nowrap">Destination Essaouira</span>
            </div>
            <p className="text-3xl font-serif leading-tight mb-6">
              Catch Your Perfect Wave in Essaouira
            </p>
          </div>

          {/* Column 2 - Lessons */}
          <div>
            <h4 className="text-base font-bold mb-4">Lessons</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('lessons')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Surf Lessons
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('lessons')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Kitesurf Lessons
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('lessons')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Private Sessions
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Rentals */}
          <div>
            <h4 className="text-base font-bold mb-4">Rentals</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('rentals')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Surfboards
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('rentals')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Wetsuits
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('rentals')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Full Packages
                </button>
              </li>
            </ul>
          </div>

          {/* Column 4 - Info */}
          <div>
            <h4 className="text-base font-bold mb-4">Info</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('why-choose-us')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
              <li>
                <a href="#" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Lower Footer */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Copyright */}
            <p className="text-sm text-white/70">
              © 2024 Destination Essaouira. All rights reserved.
            </p>

            {/* Social Media */}
            <div className="flex items-center gap-4">
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border-2 border-white/30 rounded-lg hover:bg-white hover:text-teal-600 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border-2 border-white/30 rounded-lg hover:bg-white hover:text-teal-600 transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a 
                href="https://youtube.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border-2 border-white/30 rounded-lg hover:bg-white hover:text-teal-600 transition-all cursor-pointer"
              >
                <i className="ri-youtube-fill text-lg"></i>
              </a>
              <a 
                href="https://tripadvisor.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border-2 border-white/30 rounded-lg hover:bg-white hover:text-teal-600 transition-all cursor-pointer"
              >
                <i className="ri-map-pin-user-fill text-lg"></i>
              </a>
            </div>

            {/* Privacy Link & Readdy Credit */}
            <div className="flex items-center gap-4 text-sm text-white/70">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
